// types
import { createSlice } from '@reduxjs/toolkit';
// initial state
const initialState = {
    templates: null,
    template: null,
    currentPage: null,
    pageSize: null,
    totalAccounts: null
};

// ==============================|| SLICE - KASHIER ||============================== //

const template = createSlice({
    name: 'template',
    initialState,
    reducers: {
        setTemplates(state, action) {
            state.templates = action.payload.templates;
            state.currentPage = action.payload.pagination.currentPage;
            state.pageSize = action.payload.pagination.pageSize;
        },
        setTemplate(state, action) {
            state.template = action.payload.template;
        }
    }
});

export default template.reducer;

export const { setTemplates, setTemplate } = template.actions;
